import { IconButton, Text, Tooltip } from '@radix-ui/themes';
import { ChartBar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { track } from '../../analytics/track';
import { AnalyticsEvents } from '../../analytics/events';

const StatisticsIcon = ({ jobId }: { jobId: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Tooltip content={<Text size="3">{t('statistics.icon.tooltip')}</Text>}>
      <IconButton
        size="3"
        color="gray"
        variant="soft"
        className="flex items-center justify-center ml-2"
        onClick={() => {
          track(AnalyticsEvents.STATISTICS_OPENED);
          navigate(`/job/${jobId}/statistics`);
        }}
      >
        <ChartBar />
      </IconButton>
    </Tooltip>
  );
};

export default StatisticsIcon;
